import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HistoricalConsultationDetail from './pages/historical-consultation-detail';
import UserProfileAndSystemSettings from './pages/user-profile-and-system-settings';
import LoginScreen from './pages/login-screen';
import TaxCalculationResults from './pages/tax-calculation-results';
import ConsultationHistory from './pages/consultation-history';
import NewTaxConsultationForm from './pages/new-tax-consultation-form';
import ProductTaxDetailPanel from './pages/product-tax-detail-panel';
import TaxConsultationDashboard from './pages/tax-consultation-dashboard';
import CompanyManagement from "./pages/company-management";

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
        <Route path="/" element={<LoginScreen />} />
        <Route path="/historical-consultation-detail" element={<HistoricalConsultationDetail />} />
        <Route path="/user-profile-and-system-settings" element={<UserProfileAndSystemSettings />} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/tax-calculation-results" element={<TaxCalculationResults />} />
        <Route path="/consultation-history" element={<ConsultationHistory />} />
        <Route path="/new-tax-consultation-form" element={<NewTaxConsultationForm />} />
        <Route path="/product-tax-detail-panel" element={<ProductTaxDetailPanel />} />
        <Route path="/tax-consultation-dashboard" element={<TaxConsultationDashboard />} />
        <Route path="/company-management" element={<CompanyManagement />} />
        <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;